import { render, staticRenderFns } from "./HeaderPopupComponent.vue?vue&type=template&id=48d4c28f&scoped=true&"
import script from "./HeaderPopupComponent.vue?vue&type=script&lang=js&"
export * from "./HeaderPopupComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d4c28f",
  null
  
)

export default component.exports